// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__-TiKA","containerItemsCenter":"Skeleton_containerItemsCenter__2KtzV"};